<template>
    <v-combobox
            ref="searchInput"
            :menu-props="{ auto: false}"
            outlined
            v-model="model"
            :disabled="loadingCreate"
            :items="items"
            :loading="loading || loadingCreate"
            :search-input.sync="search"
            :error-messages="shouldCreate ? 'Síntoma no encontrado' : (errorMessages || null)"
            :filter="() => true"
            color="primary"
            item-text="title"
            item-value="id"
            :label="label || 'Síntoma'"
            return-object
    >
        <template slot="no-data">
            <span class="caption pa-2">Ítem no encontrado:
            <v-btn
                    :disabled="!shouldCreate"
                    color="primary"
                    rounded small
                    :loading="loadingCreate"
                    depressed
                    @click="createSymptom">crearlo</v-btn>
            </span>
        </template>

        <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-content v-text="data.item.title"></v-list-item-content>
            </template>
        </template>
    </v-combobox>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {debounce} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['value', 'errorMessages', 'label', 'attach'],
        data(){
            return {
                descriptionLimit: 60,
                symptoms: [],
                loading: false,
                loadingCreate: false,

                search: '',
                model: null,
            }
        },
        mounted(){
            this.getItems()
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            clearSearch(){
                var vm = this
                vm.search = ''
                vm.model = null
                vm.$refs.searchInput.blur()
            },
            async createSymptom(){
                var vm =this

                if(vm.search.length < 3){
                    vm.showSnackBar('El motivo debe contener al menos 3 caracteres')
                    return
                }

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                 vm.loadingCreate = true
                const response = await ApiUtils.makePost(`providers/${vm.currentProvider.id}/symptom`, {
                    description: vm.search
                })
                 vm.loadingCreate = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando guardar')
                    vm.$emit('error', json)
                    return
                }

                const json = await response.json()
                vm.symptoms.push(json.result.symptom)
                vm.$nextTick(function(){

                    const createdModel = {
                        id: json.result.symptom.id,
                        title: json.result.symptom.description,
                    }

                    vm.model = createdModel
                    vm.$emit('change', createdModel)

                })

            },
            debouncegetItems: debounce(function(){
                this.getItems()
            }, 300),
            async getItems(){

                var vm = this

                if(!vm.currentProvider){
                    throw new Error('No provider selected')
                }

                vm.loading = true
                const response = await ApiUtils.makeGet(`providers/${vm.currentProvider.id}/symptoms`, {
                    term: vm.search
                })
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error consultando antecedentes')
                    return
                }

                const json = await response.json()
                vm.symptoms = json.result.symptoms.data

               vm.$nextTick(function(){
                   if(vm.value){
                       vm.model = vm.value
                   }
               })

            }
        },
        computed: {
            ...mapState(['currentProvider']),
            shouldCreate(){
                return this.search && this.symptoms.length === 0 && (!this.model || typeof this.model === 'string') && !this.loading
            },
            items () {
                return this.symptoms.map(symptom => {
                    return {
                        id: symptom.id,
                        title: symptom.description,
                    }
                })
            }
        },
        watch: {
            search (val) {
                var vm = this
                if(vm.model && val === vm.model.title) return
                vm.model = null
                vm.loading = true
                vm.debouncegetItems()
            },
            value(val){
                this.model = val
            },
            model(val){
                if(!val) return
                const newModel = typeof val === 'string' ? null : val
                this.$emit('change', newModel)
            }
        }
    }
</script>
